var React = require('react');

function Padlock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.32 6.446h-.757V4.357C12.563 1.953 10.607 0 8.203 0c-2.404 0-4.36 1.953-4.36 4.357v2.09h-.758C2.486 6.446 2 6.93 2 7.528v7.388c0 .6.486 1.083 1.085 1.083H13.32c.6 0 1.083-.484 1.083-1.083V7.53c0-.6-.484-1.083-1.083-1.083zm-8.112 0V4.357c0-1.651 1.344-2.993 2.995-2.993 1.649 0 2.992 1.342 2.992 2.993v2.09H5.208z"}));
}

Padlock.defaultProps = {"width":"16","height":"16","fill":"#737680","viewBox":"0 0 16 16"};

module.exports = Padlock;

Padlock.default = Padlock;
